import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogV2Component } from './dialog-v2.component';

@NgModule({
  imports: [DialogV2Component],
  exports: [DialogV2Component, MatDialogModule],
})
export class DialogV2ComponentModule {}
